<template>
  <div class="companies">
    <v-card>
      <v-card-title> برای مشاهده هر طبقه بندی آن را انتخاب نمایید </v-card-title>
      <v-card-text>
        <v-treeview v-model="selectedCategories" :items="categories" item-key="_id" selectable @input="handleGetFilteredCompanies()"></v-treeview>
      </v-card-text>
    </v-card>
    <v-card class="mt-4">
      <v-card-title class="d-flex align-center mb-7">
        <h3>لیست شرکت ها</h3>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="جستجو بر اساس نام شرکت، مدیر و محصولات" class="flex-fill mx-7 mt-0 pt-0" single-line hide-details></v-text-field>
        <div v-if="selectedCompanies.length > 0">
          <v-btn depressed color="accent">
            <download-excel :data="selectedCompanies" name="export.xls" :labels="csvlabels" :fields="csvfields" type="xls" worksheet="لیست شرکت ها" class="d-flex align-center">
              <v-icon class="ml-2 text-body-2">mdi-content-save-settings-outline</v-icon>
              <small>ذخیره موارد انتخاب شده</small>
            </download-excel>
          </v-btn>
        </div>
        <div v-else>
          <v-btn depressed color="success">
            <download-excel :data="companies" name="export.xls" :labels="csvlabels" :fields="csvfields" type="xls" worksheet="لیست شرکت ها" class="d-flex align-center">
              <v-icon class="ml-2 text-body-2">mdi-content-save-settings-outline</v-icon>
              <small>ذخیره لیست شرکت ها</small>
            </download-excel>
          </v-btn>
        </div>
      </v-card-title>
      <v-data-table v-model="selectedCompanies" :headers="headers" :items="companies" :footer-props="{ 'items-per-page-options': [10, 50, 100] }" :search="search" :loading="loading" :expanded="companies" show-expand disable-sort fixed-header show-select item-key="_id">
        <template v-slot:[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <div v-if="item.promoted">
              <v-avatar color="yellow accent-4 ml-2" size="25">
                <v-icon small class="white--text">mdi-star</v-icon>
              </v-avatar>
            </div>
            <v-avatar size="35" class="ml-5">
              <v-img v-if="item.logo" :src="`http://localhost:3000/company/${item._id}/image`" />
              <v-img v-else src="~@/assets/images/logo-placeholder.jpg" />
            </v-avatar>
            <div class="text-no-wrap">{{ item.name }}</div>
          </div>
        </template>

        <template v-slot:[`item.moderator`]="{ item }">
          <div class="text-no-wrap">{{ item.moderator }}</div>
        </template>

        <template v-slot:[`item.product`]="{ item }">
          <div class="thin black--text" style="font-size: 14px">
            {{ item.product }}
          </div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="d-flex align-center py-3">
              <div class="text-caption flex-fill">
                <strong>آدرس: </strong>
                <span v-if="item.address">{{ item.address }}</span>
                <span v-else>-</span>
                <v-chip v-if="item.postalcode" small label color="grey lighten-4" class="mr-2">
                  <div class="text-catption">کد پستی: {{ item.postalcode }}</div>
                </v-chip>
              </div>

              <v-btn class="mx-1" outlined rounded color="grey darken-3" style="height: 32px" :href="`tel:${item.tel}`" v-if="item.tel">
                <v-icon left>mdi-phone</v-icon>
                <small>{{ item.tel }}</small>
              </v-btn>

              <v-btn class="mx-1" outlined rounded color="grey darken-3" style="height: 32px" v-if="item.fax">
                <v-icon left>mdi-fax</v-icon>
                <small>{{ item.fax }}</small>
              </v-btn>

              <v-btn class="mx-1" outlined fab x-small color="grey darken-3" :href="`http://${item.website}`" target="_blank" v-if="item.website">
                <v-icon>mdi-web</v-icon>
              </v-btn>

              <v-btn class="mx-1" outlined fab x-small color="grey darken-3" :href="`mailto:${item.email}`" target="_blank" v-if="item.email">
                <v-icon>mdi-email</v-icon>
              </v-btn>

              <v-btn class="mx-1" outlined fab x-small color="grey darken-3" v-clipboard:copy="`https://polymerisapi.iranpolymer.com/api/company-data/?company_id=${item._id}`" v-clipboard:success="onCopy" v-clipboard:error="onError">
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
              <v-btn class="mx-1" outlined fab x-small color="grey darken-3" :href="`https://polymerisapi.iranpolymer.com/api/company-data/?company_id=${item._id}`" target="_blank">
                <v-icon>mdi-export-variant</v-icon>
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Companies",
  data() {
    return {
      loading: true,
      search: "",
      singleSelect: false,
      categories: [],
      selectedCategories: [],
      selectedCompanies: [],
      headers: [
        {
          text: "نام شرکت",
          value: "name",
          align: "center",
          width: 200
        },
        {
          text: "مدیر",
          value: "moderator",
          align: "center",
          width: 200
        },
        {
          text: "محصولات",
          value: "product",
          align: "center",
          width: 400
        }
      ],
      companies: [],
      csvfields: {
        نام: "name",
        مدیر: "moderator",
        محصولات: "product",
        تلفن: "tel",
        فکس: "fax",
        "کد پستی": "postalcode",
        آدرس: "address",
        وبسایت: "website",
        ایمیل: "email"
      },
      csvlabels: {
        name: "نام شرکت",
        moderator: "مدیر",
        product: "محصولات",
        tel: "تلفن",
        fax: "فکس",
        postalcode: "کد پستی",
        address: "آدرس",
        website: "وبسایت",
        email: "ایمیل"
      }
    };
  },
  created() {
    this.handleGetCompanies(this.$route.params.id);
    this.handleGetCategories(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.handleGetCompanies(to.params.id);
    this.handleGetCategories(to.params.id);
    next();
  },

  methods: {
    onCopy: function () {
      alert("آدرس در حافظه کپی شد");
    },
    onError: function () {
      alert("دریافت اطلاعات مشکلی برخورد کرد");
    },
    handleGetCompanies(id) {
      this.loading = true;
      this.companies = [];
      this.$api
        .get("companies/" + id + `?timestamp=${new Date().getTime()}`)
        .then((res) => {
          this.companies = res.data.companies;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    handleGetFilteredCompanies() {
      this.loading = true;
      this.companies = [];
      this.$api
        .post(`companies?timestamp=${new Date().getTime()}`, {
          categories: this.selectedCategories
        })
        .then((res) => {
          this.companies = res.data.companies;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    handleGetCategories(id) {
      var route = 0;
      if (id == "plastic") {
        route = 1;
      } else if (id == "glue") {
        route = 2;
      } else if (id == "packing") {
        route = 3;
      }
      this.$api.get("categories/" + route).then((res) => {
        this.categories = res.data.data;
      });
    }
  }
};
</script>

<style>
.v-data-table > .v-data-table__wrapper tbody tr {
  box-shadow: none !important;
}
</style>
